export default {"src":"/_next/static/media/list.f85d67ce.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};